import { Tabs } from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import { useNavigate } from 'react-router-dom';

import useQuery from '../../../util/useQuery';
import ListCard from './ListCard';
import { ROUTER } from '../../../constants/router';

const { TabPane } = Tabs;
const renderTabBar = (props, DefaultTabBar) => (
    <Sticky bottomOffset={80}>
        {({ style }) => (
            <DefaultTabBar
                {...props}
                className="bg-white z-50"
                style={{
                    ...style,
                }}
            />
        )}
    </Sticky>
);
export default function TabsList({
    period,
    selectPeriod,
    keyword,
    requestTypeId,
    setTabs,
    requestList,
    tab,
    setKeyword,
    setRequestTypeId,
    newTotal,
    verifiedTotal,
    preparingTotal,
    inProgressTotal,
    doneTotal,
    rejectTotal,
    archiveTotal,
    allRequestTotal,
    currentPage,
    setCurrentPage,
    setLoading,
    searchTable,
}) {
    const navigate = useNavigate();
    const params = useQuery();

    return (
        <div className="w-full">
            <StickyContainer>
                <Tabs
                    className="tabs bg-white p-2 rounded-md w-full"
                    activeKey={params.get('tab') || '1'}
                    // defaultActiveKey={'1'}
                    // tabBarGutter={'5%'}
                    onChange={(key) => {
                        setTabs(key);
                        navigate(`${ROUTER.DS_360.DASHBOARD}?tab=${key}`);
                        const pageValue = {
                            page: 1,
                            pageSize: 10,
                            sortBy: 'requestDate',
                            sortDirection: 'DESC',
                            total: 0,
                        };
                        setCurrentPage(pageValue);
                        // setLoading(true)
                        searchTable(
                            period,
                            selectPeriod,
                            key,
                            '',
                            '',
                            pageValue
                        );
                    }}
                    renderTabBar={renderTabBar}
                >
                    <TabPane
                        tab={
                            <span className="text-sm font-semibold">
                                {`New (${newTotal})`}{' '}
                            </span>
                        }
                        key={1}
                    >
                        <ListCard
                            setLoading={setLoading}
                            period={period}
                            selectPeriod={selectPeriod}
                            keyword={keyword}
                            requestTypeId={requestTypeId}
                            tab={tab}
                            setRequestTypeId={setRequestTypeId}
                            setKeyword={setKeyword}
                            requestList={requestList}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="text-sm font-semibold">{`Verified (${verifiedTotal})`}</span>
                        }
                        key={2}
                    >
                        <ListCard
                            setLoading={setLoading}
                            period={period}
                            selectPeriod={selectPeriod}
                            keyword={keyword}
                            requestTypeId={requestTypeId}
                            tab={tab}
                            setRequestTypeId={setRequestTypeId}
                            setKeyword={setKeyword}
                            requestList={requestList}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="text-sm font-semibold">{`Preparing (${preparingTotal})`}</span>
                        }
                        key={3}
                    >
                        <ListCard
                            setLoading={setLoading}
                            period={period}
                            selectPeriod={selectPeriod}
                            keyword={keyword}
                            requestTypeId={requestTypeId}
                            tab={tab}
                            setRequestTypeId={setRequestTypeId}
                            setKeyword={setKeyword}
                            requestList={requestList}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="text-sm font-semibold">{`In progress (${inProgressTotal})`}</span>
                        }
                        key={4}
                    >
                        <ListCard
                            setLoading={setLoading}
                            period={period}
                            selectPeriod={selectPeriod}
                            keyword={keyword}
                            requestTypeId={requestTypeId}
                            tab={tab}
                            setRequestTypeId={setRequestTypeId}
                            setKeyword={setKeyword}
                            requestList={requestList}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="text-sm font-semibold">{`Done (${doneTotal})`}</span>
                        }
                        key={5}
                    >
                        <ListCard
                            setLoading={setLoading}
                            period={period}
                            selectPeriod={selectPeriod}
                            keyword={keyword}
                            requestTypeId={requestTypeId}
                            tab={tab}
                            setRequestTypeId={setRequestTypeId}
                            setKeyword={setKeyword}
                            requestList={requestList}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="text-sm font-semibold">{`Reject (${rejectTotal})`}</span>
                        }
                        key={6}
                    >
                        <ListCard
                            setLoading={setLoading}
                            period={period}
                            selectPeriod={selectPeriod}
                            keyword={keyword}
                            requestTypeId={requestTypeId}
                            tab={tab}
                            setRequestTypeId={setRequestTypeId}
                            setKeyword={setKeyword}
                            requestList={requestList}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="text-sm font-semibold">{`Archived (${archiveTotal})`}</span>
                        }
                        key={7}
                    >
                        <ListCard
                            setLoading={setLoading}
                            period={period}
                            selectPeriod={selectPeriod}
                            keyword={keyword}
                            requestTypeId={requestTypeId}
                            tab={tab}
                            setRequestTypeId={setRequestTypeId}
                            setKeyword={setKeyword}
                            requestList={requestList}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="text-sm font-semibold">{`All Request (${allRequestTotal})`}</span>
                        }
                        key={8}
                    >
                        <ListCard
                            setLoading={setLoading}
                            period={period}
                            selectPeriod={selectPeriod}
                            keyword={keyword}
                            requestTypeId={requestTypeId}
                            tab={tab}
                            setRequestTypeId={setRequestTypeId}
                            setKeyword={setKeyword}
                            requestList={requestList}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </TabPane>
                </Tabs>
            </StickyContainer>
        </div>
    );
}
